import React from 'react';
import {noop} from 'lodash';

import {ClientJourneyTask} from '/component/partial/report/ClientJourneyTask';
import {FrontlineClientRole} from '/component/partial/report/FrontlineClientRole';
import {PeopleRole} from '/component/partial/report/PeopleRole';
import PersonFullName from '/component/partial/report/PersonFullName';
import {NEXT_TASK} from '/enum/peopleToContact.enum';
import {
  REPORT_CLIENT_TO_CONTACT,
  REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
} from '/enum/records.enum';
import {FILTER_TYPES} from '/enum/tealium.enum';

import {generateOnRecordPress} from '../PeopleToContact.util';
import {PeopleToContactDataProvider} from '../PeopleToContactDataProvider';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface NextTaskProps {
  featureFlag: {
    CC_SR: boolean;
  };
  onItemPress: (item: any) => void;
  onShowProfile: () => void;
  parentScreenName: string;
  showFullReport: boolean;
  reportParams: any;
}

export const NextTask: React.FC<NextTaskProps> = ({
  onItemPress = noop,
  onShowProfile = noop,
  parentScreenName = '',
  showFullReport = false,
  reportParams = null,
  featureFlag = {
    CC_SR: false,
  },
}) => {
  const {sortParam} = useRecordsSorting({
    recordsName: REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
  });

  const onViewMore = () => {
    onItemPress({
      value: 0,
      recordsName: REPORT_CLIENT_TO_CONTACT,
      filterName: REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
    });
  };

  // if the context has not been initialized yet, we take sorting from
  // the parent (default sorting)
  const defaultSorting = sortParam?.params
    ? [{...sortParam?.params}]
    : reportParams;

  return (
    <PeopleToContactDataProvider
      screenParams={{type: NEXT_TASK}}
      clientMilestone={FILTER_TYPES.nextTask}
      onViewMore={onViewMore}
      reportParams={defaultSorting}
      reportName={REPORT_CLIENT_TO_CONTACT_NEXT_TASK}
      parentScreenName={parentScreenName}
      dataRendererProps={{
        personNameComponent: PersonFullName,
        personRoleComponent: featureFlag.CC_SR
          ? PeopleRole
          : FrontlineClientRole,
        personInfoComponent: ClientJourneyTask,
        onRecordPress: generateOnRecordPress({
          onShowProfile,
        }),
        showFullReport,
      }}
    />
  );
};
